module.exports = __webpack_public_path__ + "img/play-1.df9c6e7e.png";